export enum TournamentEventAction {
    OPEN = 'OPEN',
    HELD = 'HELD',
    FINISH = 'FINISH',
    CANCEL = 'CANCEL',
    UPDATE = 'UPDATE',
    PARTICIPANT_UPDATE = 'PARTICIPANT_UPDATE',
    STATISTICS_UPDATE = 'STATISTICS_UPDATE',
    MATCH_RESULT_UPDATE = 'MATCH_RESULT_UPDATE',
}
